import React, { JSX } from 'react';
import { ApiFlightSegment } from '@ibe/api';
import DateDisplay from '../../Components/UI/DateDisplay/DateDisplay';

interface SegmentDisplayProps {
  segment: ApiFlightSegment;
}

const SegmentDisplay = (props: SegmentDisplayProps): JSX.Element => {
  const { segment } = props;

  return (
    <>
      {segment.legs.map(leg => (
        <div className="container" key={leg.id}>
          <div className="row">
            <div className="col-4 col-md-2" />
            <div className="col-8 col-md-10">
              {leg.operatingCarrier.name}
              {', '}
              {leg.operatingCarrier.code + leg.flightNumber}
            </div>
          </div>
          <div className="row">
            <div className="col-4 col-md-2">
              <DateDisplay utc date={leg.departure} format="HH:mm" />
            </div>
            <div className="col-8 col-md-10">
              {leg.origin.description} ({leg.origin.code})
            </div>
          </div>
          <div className="row">
            <div className="col-4 col-md-2">
              <DateDisplay utc date={leg.arrival} format="HH:mm" />
              {leg.dateDeviation > 0 && <sup>+{leg.dateDeviation}</sup>}
            </div>
            <div className="col-8 col-md-10">
              {leg.destination.description} ({leg.destination.code})
            </div>
          </div>
        </div>
      ))}
      <br />
    </>
  );
};

export default SegmentDisplay;
